import { ProgressBar } from "primereact/progressbar";
import { forwardRef, useContext, useEffect, useState } from "react";
import formatSecondsToHMS from "../../../helpers/formatSecondsToHMS";
import { getQuizFromLocalStorage } from "../../../helpers/localStorageHelper";
import { TopikTestContext } from "./TakeTest";

const TestTimer = forwardRef(({ duration, isSubmitted, handleTimeUp }, ref) => {
  const [timeLeft, setTimeLeft] = useState(duration * 60);
  const [progress, setProgress] = useState(100);
  const { translation } = useContext(TopikTestContext);

  useEffect(() => {
    if (timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prev) => {
          ref.current = prev - 1;
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timeLeft]);

  useEffect(() => {
    setProgress((timeLeft / (duration * 60)) * 100);
  }, [timeLeft, duration]);

  useEffect(() => {
    if (isSubmitted) return;
    if (timeLeft === 0) {
      handleTimeUp();
    }
  }, [timeLeft, isSubmitted]);

  return (
    <div className="w-full test-timer-container">
      <div className="flex justify-content-between align-items-center mb-2">
        <div className={`p-0 flex align-items-center gap-2 font-semibold text-lg`}>
          <i className="pi pi-clock text-default-txt-color text-2xl"></i>
          <h5 className="keduall-typography heading-h5-semibold-600 text-default-txt-color">{translation?.testTimerTitle}:</h5>
          <h5 className="keduall-typography heading-h5-bold-700 text-default-txt-color">{formatSecondsToHMS(timeLeft)}</h5>
        </div>
      </div>
      <ProgressBar value={progress} showValue={false} className="height-14"></ProgressBar>
    </div>
  );
});
export default TestTimer;
